import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiBox from '@mui/material//Box';
import Button from '../Button/Button.js';
import '../Button/SplitButton.js';

const Root = styled(MuiBox) `
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(8, 8, 0)};
`;
const MainActionsWrapper = styled(MuiBox) `
  display: flex;
  flex-direction: row;
  justify-content: center;
  > :not(:first-of-type) {
    margin: ${({ theme }) => theme.spacing(0, 0, 0, 4)};
  }
`;
const SideActionWrapper = styled(MuiBox) `
  flex: 1;
  display: flex;
  margin: ${({ theme }) => theme.spacing(0, 4, 0, 0)};
`;
const Actions = ({ mainActions = [], sideAction }) => {
    return (jsxs(Root, Object.assign({ className: "actionsWrapper" }, { children: [jsx(SideActionWrapper, { children: sideAction }), jsx(MainActionsWrapper, Object.assign({ "data-testid": "dialog-main-actions" }, { children: mainActions.map((_a, index) => {
                    var { title } = _a, rest = __rest(_a, ["title"]);
                    const defeaultVariant = index < mainActions.length - 1 ? 'secondary' : 'primary';
                    return (jsx(Button, Object.assign({ "data-testid": title, variant: defeaultVariant }, rest, { size: "large" }, { children: title }), title));
                }) }))] })));
};

export { Actions as default };
//# sourceMappingURL=Actions.js.map
